import React, { useState, useEffect } from "react";
import {
    Card,
    Form,
    Modal,
    Input,
    Select,
    Checkbox,
    Button,
    DatePicker,
    ConfigProvider
} from 'antd';
import MaskedInput from "antd-mask-input";
import { useDispatch, useSelector } from "react-redux";
import { dealerRegister } from "../actions/dealerRegister";
import { } from "../actions/dealerRegister";
import MembershipContract from "./popupScreen/MembershipContract";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from "axios";
import 'moment/locale/tr';


function Register() {
    const [city, setCity] = useState([]);
    const [district, setDistrict] = useState([]);
    const [password, setPasswordValidate] = useState([]);
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const { dealerSave } = useSelector(state => state.auth);
    const [validate, setValidate] = useState({});
    const [email, setEmail] = useState('');
    const [value, setValue] = useState('');
    const dispatch = useDispatch();
    const { Option } = Select;
    const [modalOpen, setModalOpen] = useState(false);
    const [memberModalOpen, setMemberModalOpen] = useState(false);
    const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY'];
    const [birthdate, setBirthdate] = useState(false);
    const [companyOwnerBirthDate, setCompanyOwnerBirthDate] = useState(false);
    const [tradeAuthorizationCertificateDate, setTradeAuthorizationCertificateDate] = useState(false);


    console.log(checked);
    const [username, setUsername] = useState('');

    const { success, error, info } = Modal;

    let date = new Date();

    useEffect(() => {
        fetch("/authservice-api/city/getAllCities")
            .then(response => response.json())
            .then(response => setCity(response));
    }, []);


    const getDistrictNameByCityId = (value) => {
        console.log(`Selected: ${value}`);
        axios("/authservice-api/city/getDistrictByCityId/", {
            method: 'POST',
            params: { name: value }
        })
            .then(response => setDistrict(response.data))
            .catch((error) => {
                console.error(error);
            });
    };

    const showConfirm = () => {
        success({
            title: 'Bilgi',
            icon: <ExclamationCircleOutlined />,
            content: "Bayi Bilgileri Kayıt Edildi",
            okText: 'Tamam',
            onOk() {
                console.log('OK');
                afterClose: window.open('/authservice-ui/index.html', "_self")
            },
        });
    };

    const showError = (err) => {
        error({
            title: 'Hata',
            icon: <ExclamationCircleOutlined />,
            content: err ? err : "Bayi bilgileri kayıt edilirken hata oluştu. Bilgileri kontrol ediniz.",
            okText: 'Tamam',
            onOk() {
                setLoading(false);
            },
        });
    };


    var __membershipHtml = require("../files/membership.html.js");
    var membershipTemplate = { __html: __membershipHtml };

    var __disclosureHtml = require("../files/disclosure.html.js");
    var disclosureTemplate = { __html: __disclosureHtml };

    var __dataProcessHtml = require("../files/dataprocess.html.js");
    var dataProcessTemplate = { __html: __dataProcessHtml };

    const showMembershipModal = () => {
        info({
            title: 'Üyelik Sözleşmesi',
            icon: <ExclamationCircleOutlined />,
            content: <div className="screen-share"><span dangerouslySetInnerHTML={membershipTemplate} /></div>,
            okText: 'Tamam',
            width: '80%',
            onOk() {
            },
        });
    };

    const showDiclosureModal = () => {
        info({
            title: 'OtoSor Tüzel Kişi Temsilci Aydınlatma Formu',
            icon: <ExclamationCircleOutlined />,
            content: <div className="screen-share"><span dangerouslySetInnerHTML={disclosureTemplate} /></div>,
            okText: 'Tamam',
            width: '80%',
            onOk() {
            },
        });
    };

    const showDataProcessModal = () => {
        info({
            title: 'Veri İşleme Sözleşmesi',
            icon: <ExclamationCircleOutlined />,
            content: <div className="screen-share"><span dangerouslySetInnerHTML={dataProcessTemplate} /></div>,
            okText: 'Tamam',
            width: '80%',
            onOk() {
            },
        });
    };

    const handleDealerInfoSave = (values) => {
        let {
            companyTitle,
            taxAdministration,
            taxNumber,
            city,
            district,
            dealerAddress,
            storeLink,
            hasTradeAuthorizationCertificate,
            tradeAuthorizationCertificateNumber,
            tradeAuthorizationCertificateDate,
            companyOwnerName,
            companyOwnerSurname,
            tcNo,
            birtdate,
            email,
            mobilePhone,
            phoneNumber,
            companyManagerName,
            companyManagerSurname,
            companyManagerTcNo,
            companyManagerBirtdate,
            membershipContract,
            disclosure,
            dataProcess,
            etkPermission,
            password,
            againPassword,
            createDate,
        } = values;
        setLoading(true);
        dispatch(dealerRegister(companyTitle,
            taxAdministration,
            taxNumber,
            city,
            district,
            dealerAddress,
            storeLink,
            hasTradeAuthorizationCertificate,
            tradeAuthorizationCertificateNumber,
            tradeAuthorizationCertificateDate,
            companyOwnerName,
            companyOwnerSurname,
            tcNo,
            birtdate,
            email,
            mobilePhone,
            phoneNumber,
            companyManagerName,
            companyManagerSurname,
            companyManagerTcNo,
            companyManagerBirtdate,
            membershipContract,
            disclosure,
            dataProcess,
            etkPermission,
            password,
            againPassword,
            createDate = date))
            .then((responseData) => {
                console.log(responseData);
                if (responseData.code === '0000') {
                    showConfirm();
                } else {
                    error({
                        title: 'Hata',
                        icon: <ExclamationCircleOutlined />,
                        content: responseData.message,
                        okText: 'Tamam',
                        onOk() {
                            setLoading(false);
                            console.log('hataaaa');
                        },
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                showError(err);
            });

    };

    const onChange = (date) => {
        console.log(date);
    };

    return (
        <div className="form_design_register">
            <Card title="Bayi Üyelik">
                <Form onFinish={handleDealerInfoSave} layout="vertical"
                    initialValues={{
                        membershipContract: false,
                        disclosure: false,
                        dataProcess: false,
                        etkPermission: false,
                    }}
                >
                    <Form.Item
                        name="companyTitle"
                        label="Şirket Ünvanı:"
                        rules={[
                            {
                                required: true,
                                message: 'Lütfen şirket ünvanı bilgisini giriniz.',
                            },
                        ]}
                    >
                        <Input placeholder="Şirket Ünvanı" size="large" />
                    </Form.Item>

                    <Form.Item label="Vergi Dairesi/Vergi Numarası:" style={{ marginBottom: 0 }}>
                        <Form.Item
                            name="taxAdministration"
                            rules={[{ required: true, message: 'Lütfen vergi dairesi bilgisini giriniz.' }]}
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)' }}
                        >
                            <Input placeholder="Vergi Dairesi" size="large" />
                        </Form.Item>
                        <Form.Item
                            name="taxNumber"
                            rules={[{
                                required: true,
                                message: 'Lütfen vergi no için geçerli bir değer giriniz yada boş bırakınız.'
                            }]}
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)', margin: '0 10px' }}
                        >
                            <Input
                                size="large"
                                maxLength="10"
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }} placeholder="1234567890" />
                        </Form.Item>
                    </Form.Item>

                    <Form.Item name="city"
                        label={"İl:"}
                        rules={[{ required: true, message: 'Lütfen il bilgisini giriniz.' }]}
                    >
                        <Select
                            showSearch
                            size="large"
                            placeholder="Adres İl"
                            value={value}
                            onChange={getDistrictNameByCityId}
                        >
                            {
                                city.map(item => (
                                    <Option value={item.name}>{item.name}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="district"
                        label={"İlçe:"}
                        rules={[{ required: true, message: 'Lütfen ilçe bilgisini giriniz.' }]}

                    >
                        <Select
                            showSearch
                            size="large"
                            placeholder="Adres İlçe"
                            value={value}
                        >
                            {
                                district.map(item => (
                                    <Option value={item.name}>{item.name}</Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        name="dealerAddress"
                        label="Bayi Adresi:"
                        rules={[
                            {
                                required: true,
                                message: 'Lütfen bayi adresi alanını giriniz.',
                            },
                        ]}>
                        <Input size="large" placeholder="Bayi Adresi" />
                    </Form.Item>

                    <Form.Item
                        name="storeLink"
                        label="Mağaza Linki:"
                        rules={[
                            {
                                required: true,
                                message: 'Lütfen şirket mağaza linkini giriniz.',
                            },
                        ]}>
                        <Input size="large" placeholder="https://otosor.sahibinden.com" />
                    </Form.Item>

                    <Form.Item
                        name="tradeAuthorizationCertificate"
                        label="Ticaret Yetki Belgesi Düzenlenme Numarası/Tarihi:"
                        >
                        <Form.Item
                            name="tradeAuthorizationCertificateNumber"
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)'}}
                        >
                            <Input
                                size="large"
                                maxLength="8"
                                onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }} placeholder="1234567" />
                        </Form.Item>

                        <Form.Item
                            name="tradeAuthorizationCertificateDate"
                            style={{ display: 'inline-block', width: 'calc(50% - 15px)', margin: '0 10px' }}
                        >

                        <Input style={{ width: '100%' }} size="large" type="date" onChange={(event) => setTradeAuthorizationCertificateDate({ startDate: event.target.value })} />

                        </Form.Item>
                    </Form.Item>

                    <Form.Item label="Firma Sahibi Adı/Firma Sahibi Soyadı:" style={{ marginBottom: 0 }}>
                        <Form.Item
                            name="companyOwnerName"
                            rules={[{ required: true, message: 'Lütfen firma sahibi adını giriniz.' }]}
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)' }}
                        >
                            <Input placeholder="Firma Sahibi Adı" size="large" />
                        </Form.Item>
                        <Form.Item
                            name="companyOwnerSurname"
                            rules={[{ required: true, message: 'Lütfen firma sahibi soyadını giriniz.' }]}
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)', margin: '0 8px' }}
                        >
                            <Input placeholder="Firma Sahibi Soyadı" size="large" />
                        </Form.Item>
                    </Form.Item>
                    <Form.Item
                        name="tcNo"
                        label="TC No:"
                        rules={[
                            {
                                required: true,
                                message: 'Lütfen TC kimlik numarası bilgisini giriniz.',
                            },
                        ]}>
                        <Input
                            maxLength="11"
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }} placeholder="12345678901" size="large" />
                    </Form.Item>

                    <Form.Item
                        name="birtdate"
                        label="Firma Sahibi Doğum Tarihi:"
                        rules={[
                            {
                                required: true,
                                message: 'Lütfen doğum tarihini giriniz.',
                            },
                        ]}
                    >
                        <Input style={{ width: '100%' }} size="large" type="date" onChange={(event) => setBirthdate({ startDate: event.target.value })} />
                    </Form.Item>

                    <Form.Item
                        name="email"
                        label="E-Posta:"
                        rules={[
                            {
                                required: true,
                                message: 'Lütfen e-posta adresini giriniz.',
                            },
                        ]}>
                        <Input size="large" placeholder="E-Posta" />
                    </Form.Item>
                    {/*<Form.Item
                name="email"
                label={"E-Posta:"}
            >
                <Input type="email"
                       className={`form-control ${validate.validate && validate.validate.email ? 'is-invalid ' : ''}`}
                       id="email"
                       name="email"
                       value={email}
                       placeholder="E-Posta"
                       onChange={(e) => setEmail(e.target.value)}
                       size="large"
                />
                <div
                    className={`invalid-feedback text-start ${(validate.validate && validate.validate.email) ? 'd-block' : 'd-none'}`}>
                    {(validate.validate && validate.validate.email) ? validate.validate.email[0] : ''}
                </div>
            </Form.Item>*/}

                    <Form.Item
                        name="mobilePhone"
                        label="Mobil Telefon:"
                        rules={[
                            {
                                required: true,
                                message: 'Mobil numaranızı girmeniz gerekmektedir.',
                            },
                        ]}>
                        <MaskedInput size="large"
                            mask={
                                '(500) 000-0000'
                            }
                        />
                    </Form.Item>

                    <Form.Item
                        name="phoneNumber"
                        label="Sabit Telefon:"
                    >
                        <MaskedInput size="large"
                            mask={
                                '(000) 000-0000'
                            }
                        />
                    </Form.Item>


                    <Form.Item label="Diğer Ortak Adı/Diğer Ortak Soyadı:" style={{ marginBottom: 0 }}>
                        <Form.Item
                            name="companyManagerName"
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)' }}
                        >
                            <Input placeholder="Diğer Ortak Adı" size="large" />
                        </Form.Item>
                        <Form.Item
                            name="companyManagerSurname"
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)', margin: '0 8px' }}
                        >
                            <Input placeholder="Diğer Ortak Soyadı" size="large" />
                        </Form.Item>
                    </Form.Item>

                    <Form.Item
                        name="companyManagerTcNo"
                        label="Diğer Ortak TC No:"
                        rules={[
                            {
                                required: false,
                                message: '',
                            },
                        ]}>
                        <Input
                            maxLength="11"
                            onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                    event.preventDefault();
                                }
                            }} placeholder="12345678901" size="large" />
                    </Form.Item>

                    <Form.Item
                        name="companyManagerBirtdate"
                        label="Diğer Ortak Doğum Tarihi:"
                    >
                        <Input style={{ width: '100%' }} size="large" type="date" onChange={(event) => setCompanyOwnerBirthDate({ startDate: event.target.value })} />

                    </Form.Item>

                    <Form.Item label="Parola:" style={{ marginBottom: 0 }}>
                        <Form.Item
                            name='password'
                            dependencies={['password']}
                            hasFeedback
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)' }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen parola giriniz.'
                                }
                            ]}
                        >
                            <Input.Password placeholder="Parola giriniz.." size="large" />
                        </Form.Item>
                        <Form.Item
                            name='againPassword'
                            className="input_border"
                            dependencies={['password']}
                            hasFeedback
                            style={{ display: 'inline-block', width: 'calc(50% - 10px)', margin: '0 8px' }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen Parolanızı Onaylayınız'
                                },
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('Girilen iki parola eşleşmiyor.')
                                    }
                                })
                            ]}
                        >
                            <Input.Password placeholder='Yeni Parola Tekrar' size="large" />
                        </Form.Item>

                        {/* <Form.Item
                    name="againPassword"
                    rules={[{ required: true, message:'Lütfen parolayı tekrar giriniz.' }]}
                    style={{ display: 'inline-block', width: 'calc(50% - 10px)', margin: '0 8px' }}
                >
                    <Input placeholder="Parolayı tekrar giriniz.." />
                </Form.Item>*/}
                    </Form.Item>


                    <Form.Item
                        name="membershipContract"
                        valuePropName="checked"
                    >
                        <Checkbox />&nbsp;
                        <a href="javascript:void(0)"
                            onClick={showMembershipModal}>
                            Üyelik Sözleşmesi
                        </a>
                        <text> ' ni okudum ve onaylıyorum.</text>
                        <MembershipContract isVisible={memberModalOpen}></MembershipContract>
                    </Form.Item>

                    <Form.Item
                        name="disclosure"
                        valuePropName="checked"
                    >
                        <Checkbox />&nbsp;
                        <a href="javascript:void(0)" onClick={showDiclosureModal}>
                            OtoSor Tüzel Kişi Temsilci Aydınlatma Formu
                        </a>
                        <text> 'nu okudum, anladım ve kabul ediyorum.</text>
                    </Form.Item>

                    <Form.Item
                        name="dataProcess"
                        valuePropName="checked"
                    >
                        <Checkbox />&nbsp;
                        <a href="javascript:void(0)" onClick={showDataProcessModal}>
                            Veri İşleme Sözleşmesi
                        </a>
                        <text> 'ni okudum ve onaylıyorum.</text>
                    </Form.Item>

                    <Form.Item
                        name="etkPermission"
                        valuePropName="checked"
                    >
                        <Checkbox />
                        <text> E-Posta, SMS, telefon gibi iletişim kanaları aracılığıyla her nevi tanıtım etkinlikleri ile
                            ilgili duyuru ve bilgilendirmelerin gönderilmesi, tanıtım ve pazarlama amacı ile tarafımla iletişim
                            kurulmasına ve ticari elektronik ileti gönderilmesine onay veriyorum.
                        </text>
                    </Form.Item>

                    <Form.Item>
                        <Button size="large" htmlType="submit" type="primary" disabled={loading} block>Kaydet</Button>
                    </Form.Item>

                </Form>

            </Card>
        </div>
    );
};

export default Register;